var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulateIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_11253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.9898L9.5 13.9798L13.5 17.9798L22 8.41977L20.59 7.00977L13.5 14.9798L9.5 10.9798L2 18.4898L3.5 19.9898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 4.5,
    x2: 2.5,
    y2: 24.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 20,
    x2: 24,
    y2: 20,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_11253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulateIcon1);
export default __webpack_public_path__ + "static/media/Simulate_icon_1.84dfd04ce63b7606bbd7ac4cf9d29a6a.svg";
export { ForwardRef as ReactComponent };